export default __webpack_public_path__ + "static/media/Barn-interior-01_resized.a5123442.jpg";